import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const InfoCircle = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12 11.5V16.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M12 7.51L12.01 7.49889" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}</IconWrapper>;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { InfoCircle };